<template>
    <div class="login_box">
        <div class="banner">
            <div class="top_box">
                <img class="img" src="@/assets/img/onelogo.png" alt="">
                <div class="title">碳中和评级系统</div>
            </div>
            <div class="h1">登录</div>

            <div class="loginBox">
                <a-form :model="formState" name="basic" :layout="layout" @finish="onFinish" @finishFailed="onFinishFailed">
                    <!-- 行1 -->
                    <a-row :gutter="[24,24]">
                        <a-col :span="24">
                            <a-form-item label="用户名" name="userName" :rules="[{ required: true, message: 'Please input your userName!' }]">
                                <a-input v-model:value="formState.userName" placeholder="用户名">
                                    <template #prefix>
                                        <user-outlined type="user" />
                                    </template>
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item label="密码" name="passWord" :rules="[{ required: true, message: 'Please input your userName!' }]">
                                <a-input-password v-model:value="formState.passWord" placeholder="输入密码">
                                    <template #prefix>
                                        <LockOutlined class="site-form-item-icon" />
                                    </template>
                                </a-input-password>
                            </a-form-item>
                        </a-col>

                        <a-col :span="24">
                            <a-form-item>
                                <a-button class="sub_btn" html-type="submit">登录</a-button>
                                <a-button type="link" block class="alink" @click="gotoPath">跳转到企业登录</a-button>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { UserOutlined, LockOutlined  } from '@ant-design/icons-vue';
import { useLoginStore } from '@/store/login'
import JSEncrypt from 'jsencrypt' //RSA加密

export default {
    name: 'index',
    components:{UserOutlined, LockOutlined},
    setup() {
        const data = reactive({
            formState:{
                userName:null,
                passWord:null,
            },
            url:[
                {
                    key:"message.cnri-tuv.com",//国内测试环境
                    value:"http://message.cnri-tuv.com:9318"
                },
                {
                    key:"admin.cnri-tuv.com",//国内产品环境
                    value:"https://www.cnri-tuv.com"
                },
                {
                    key:"cnrs.oci-dev.mvgx.com",//国外dev环境
                    value:"https://cnri.oci-dev.mvgx.com"
                },
                {
                    key:"cnrs.test.mvgx.com",//国外iwt环境
                    value:"https://cnri.test.mvgx.com"
                },
                {
                    key:"www.cnrs.mvgx.com",//国外生产环境
                    value:"https://www.cnri.mvgx.com"
                },
                {
                    key:"cnrs.local.mvgx.com",//本地测试环境
                    value:"https://cnrs.local.mvgx.com"
                },
            ],
            pubKey:'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDElNdo5+EynzJ7DucbjWoo66jTxDe5Qtk49DHt3ScE2fmrtR92j9QAuxb+qiI84zPJ1V12ls9/sqD2oHR2G+JznCUvloJMvELhQbnwicXC8wF8B1dSNkHQuBxP7iQx93lqBFzAVJii5UI9n2XkdhwXcd2cSwaAtrZI3qk0q8v3OQIDAQAB',
            layout:'vertical',
        })
        const router = useRouter()
        //引入数据管理库
        const LoginStore = useLoginStore()
        //RSA加密
        const entry = new JSEncrypt()
        entry.setPublicKey(data.pubKey)
        //跳转企业端
        const gotoPath = () => {
            let name = location.hostname
            for(let i = 0 ; i < data.url.length; i++){
                if(name == data.url[i].key){
                    window.open(data.url[i].value)
                    return
                }
            }
        }
        //表单验证成功事件
        const onFinish = values => {
            let params = {
                username:data.formState.userName,
                password:entry.encrypt(data.formState.passWord),//加密密码
                clientType:1,
                platformType:64
            }
            LoginStore.login(params,router)
        };
        //表单验证失败事件
        const onFinishFailed = errorInfo => {
            console.log('Failed:', errorInfo);
        };
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            LoginStore,
            onFinish,
            gotoPath,
            onFinishFailed,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.login_box{
    width: 100vw;
    height: 100vh;
    background: #163B7F;
    display: flex;
    justify-content: center;
    align-items: center;
    .banner{
        padding: 50px 150px;
        background: #FFFFFF;
        border-radius: 10px;
        box-shadow: 1px 2px 10px#000000d9;
        min-width: 590px;
        .h1{
            font-size: 40px;
            font-weight: 600;
            color: #00142A;
            line-height: 48px;
            text-align: center;
            margin: 30px 0;
        }
        .top_box{
            display: flex;
            align-items: center;
            justify-content: center;
            .img{
                width: 80px;
                height: 80px;
            }
            .title{
                font-size: 24px;
                font-weight: 600;
                color: #00142A;
                line-height: 48px;
                margin-left: 30px;
            }
        }
    }
    
}
.ant-input{
    width: 100%;
}
.sub_btn{
    width: 100%;
    height: 50px;
    border-radius: 4px;
    background: #163B7F;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 17px;
}
.sub_btn:hover,.sub_btn:focus{
    background: #163B7F;
    border-color: #163B7F;
    color: #FFFFFF;
}

</style>